import Vue from "vue";

import http from ":http";

import { SET_TEMPLATE } from ":mutations";
import { REQUEST_TEMPLATES, UPDATE_TEMPLATE, UPDATE_TEMPLATES } from ":actions";

const state = {
  templates: {},
  templateIds: {}
};

const mutations = {
  [SET_TEMPLATE](
    { templates, templateIds },
    { template, value, json = false }
  ) {
    Vue.set(
      templates,
      template,
      json ? JSON.parse(value.content) : value.content
    );
    Vue.set(templateIds, template, value.id);
  }
};

const actions = {
  [REQUEST_TEMPLATES]({ commit }, { templates, json = [] }) {
    return http.get(`/templates/${templates.join(",")}/latest`).then(response =>
      Object.keys(response.data)
        .map(template => ({
          template,
          value: response.data[template],
          json: json.includes(template)
        }))
        .forEach(template => commit(SET_TEMPLATE, template))
    );
  },

  [UPDATE_TEMPLATE]({ commit }, { template, content, json = false }) {
    content = json ? JSON.stringify(content) : content;

    return http.post(`/templates/${template}/`, { content }).then(response =>
      commit(SET_TEMPLATE, {
        template,
        value: response.data,
        json
      })
    );
  },

  [UPDATE_TEMPLATES]({ commit }, { templates, json = [] }) {
    const isJson = template => json.includes(template);
    const formattedTemplates = Object.keys(templates)
      .map(key => ({ key, value: templates[key] }))
      .map(({ key, value }) => ({
        [key]: isJson(key) ? JSON.stringify(value) : value
      }))
      .reduce((acc, obj) => Object.assign(acc, obj), {});

    return http.post("/templates", formattedTemplates).then(response =>
      Object.keys(response.data).forEach(template =>
        commit(SET_TEMPLATE, {
          template,
          value: response.data[template],
          json: isJson(template)
        })
      )
    );
  }
};

const getters = {};

export default {
  state,
  mutations,
  actions,
  getters
};
